import { ReactNode, createContext, useContext, useState } from 'react';

interface SwitchWorkspaceModalContextData {
    isModalOpen: boolean;
    openModal: () => void;
    closeModal: () => void;
}

const SwitchWorkspaceModalContext = createContext<SwitchWorkspaceModalContextData | null>(null);

export const SwitchWorkspaceModalProvider = ({ children }: { children: ReactNode }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);

    return (
        <SwitchWorkspaceModalContext.Provider value={{ isModalOpen, openModal, closeModal }}>
            {children}
        </SwitchWorkspaceModalContext.Provider>
    );
};

export const useSwitchWorkspaceModalContext = () => {
    const context = useContext(SwitchWorkspaceModalContext);

    if (!context) {
        throw new Error('useSwitchWorkspaceModalContext must be used within a SwitchWorkspaceModalProvider');
    }

    return context;
};
